import axios from 'axios'
import { notification } from '../../helpers/notification'
import { api } from '@/helpers/api'

export const SubMixin = {
    data() {
        return {
            isAuthed: null,
            isArtist: null,
            isVenue: null,
            isVerified: null,
            plans: [],
            paymentMethods: [],
            addNewCard: false,
            role: '',
            showPaymentModal: false,
            subPlans: [
                {
                    planName: 'Basic',
                    subscriptionName: 'VenueFree',
                    planFeatures: 'Booking Manager Lite',
                    planPrice: 'Free',
                    icon: '/images/global/icon-yes-art.png',
                    disableIcon: '/images/global/icon-no-art.png',
                    button: 'Create Account',
                    authButton: 'Upgrade',
                    isProBtn: 'Downgrade',
                    planAddInfo: 'Plus Booking Fees',
                    listOfPlanFeatures: {
                        SectionName: ['Booking Manager Lite', 'Talent Management'],
                        subPointsList: [
                            {
                                SubPoint: 'Manage up to 5 Shows at the Same Time',
                                subStatus: true,
                                tooltip: 'Manage your shows from start to finish.'
                            },
                            {
                                SubPoint: 'Events Calendar',
                                subStatus: true,
                                tooltip: 'See what needs to get done with your personalized at-a-glance calendar.'
                            },
                            {
                                SubPoint: 'Check Avails',
                                subStatus: true,
                                tooltip:
                                    'Share unique event links with your current roster, exclusive Hedlyner talent, or new artists off the street. '
                            },
                            {
                                SubPoint: 'Centralized Inbox',
                                subStatus: true,
                                tooltip:
                                    'No more checking texts, emails, DMs, and voicemails. Get a smarter inbox. Make offers. Accept counteroffers. '
                            },
                            {
                                SubPoint: '5% In-App Booking Fee',
                                subStatus: true,
                                tooltip:
                                    'The transaction fee is calculated based on the booking rate and added to the total amount debited from your account. For example,the total amount debited from your account for a $100 booking rate is $105. '
                            },
                            {
                                SubPoint: 'Pay with Credit Cards',
                                subStatus: true,
                                tooltip:
                                    'Pay artists quickly through a trusted platform. Funds are released after the show.'
                            },
                            {
                                SubPoint: 'Event Wrap-up',
                                subStatus: true,
                                tooltip: 'Track payment management with the post-show payout summary.'
                            },
                            {
                                SubPoint: 'Reviews and Ratings',
                                subStatus: true,
                                tooltip: 'Share feedback with your community. Learn from your peers. '
                            }
                        ],
                        TalentPointsList: [
                            {
                                TalentPoint: 'Discover Artists',
                                manageStatus: true,
                                tooltip:
                                    'Search for public artist profiles and quickly see who`s a good match. Listen to their music and see their reach all in one convenient place.'
                            },
                            {
                                TalentPoint: 'Artists Network',
                                manageStatus: true,
                                tooltip: 'Keep track of booked artists and new talent in one centralized place.'
                            }
                        ]
                    }
                },
                {
                    planName: 'Pro',
                    subscriptionName: 'VenuePro',
                    planPrice: '$39/mo',
                    icon: '/images/global/Icons-pro.png',
                    button: 'Create Account',
                    authButton: 'Upgrade',
                    planFeatures: 'Everything in Lite, plus...',
                    planAddInfo: 'Billed Annually, or $45/mo billed monthly',
                    listOfPlanFeatures: {
                        SectionName: ['Booking Manager Pro'],
                        subPointsList: [
                            {
                                SubPoint: 'Manage up to 10 Shows at the Same Time',
                                subStatus: true,
                                tooltip: 'Manage your shows from start to finish.'
                            },
                            {
                                SubPoint: '0% In-App Booking Fee',
                                subStatus: true,
                                tooltip: "We'll waive venue fees added to the artist Payout."
                            },
                            {
                                SubPoint: 'Event Promotion Tools',
                                subStatus: true,
                                tooltip: 'Share beautifully created event pages with just the click of a button.'
                            }
                        ]
                    }
                },
                {
                    planName: 'Growth',
                    subscriptionName: 'VenueGrowth',
                    planPrice: '$64/mo',
                    planAddInfo: 'Billed Annually, or $75/mo billed monthly',
                    planFeatures: 'Everything in Pro, plus...',
                    icon: '/images/global/Icons-growth.png',
                    button: 'Create Account',
                    authButton: 'Upgrade',
                    listOfPlanFeatures: {
                        SectionName: [],
                        subPointsList: [
                            {
                                SubPoint: 'Manage up to 20 Shows at the Same Time',
                                subStatus: true,
                                tooltip: 'Manage your shows from start to finish.'
                            }
                        ]
                    }
                },
                {
                    planName: 'Premium',
                    subscriptionName: 'VenuePremium',
                    planPrice: '$98/mo',
                    icon: '/images/global/Icons-yes.png',
                    button: 'Create Account',
                    authButton: 'Upgrade',
                    planFeatures: 'Everything in Growth, plus...',
                    planAddInfo: 'Billed Annually, or $115/mo billed monthly',
                    listOfPlanFeatures: {
                        SectionName: [],
                        subPointsList: [
                            {
                                SubPoint: 'Unlimited Shows',
                                subStatus: true,
                                tooltip: 'Manage your shows from start to finish.'
                            }
                        ]
                    }
                }
            ],
            subPlansArtist: [
                {
                    planName: 'Pro Account',
                    planPrice: 'Free',
                    subscriptionName: 'ArtistFree',
                    planAddInfo: 'Plus 8% Commission for Confirmed Bookings',
                    planFeatures: 'Features:',
                    mainFeature: ['Manage Unlimited Gigs', 'Booking Manager Lite'],
                    listOfPlanFeatures: {
                        SectionName: ['Booking Manager Pro', 'Account Management'],
                        subPointsList: [
                            {
                                SubPoint: 'Manage Unlimited Gigs',
                                subStatus: true,
                                tooltip: 'Book as many shows as you want. Keep track of them all in one place.'
                            },
                            {
                                SubPoint: 'Streamline Booking',
                                subStatus: true,
                                tooltip: 'Make offers, negotiate rates, accept bookings.'
                            },
                            {
                                SubPoint: 'Discover new opportunities',
                                subStatus: true,
                                tooltip: 'Easily search for all open events in your area. '
                            },
                            {
                                SubPoint: 'Show Promotion Tools',
                                subStatus: true,
                                tooltip:
                                    'Share beautifully created event pages with just the click of a button, if available from venue.'
                            },
                            {
                                SubPoint: 'Direct Payments',
                                subStatus: true,
                                tooltip: 'Get paid automatically as soon as the show is over.'
                            },
                            {
                                SubPoint: 'Reviews and Ratings',
                                subStatus: true,
                                tooltip:
                                    'Share feedback with your community. Learn from your peers. Standout for being on your game.'
                            },
                            {
                                SubPoint: 'Share Avails',
                                subStatus: true,
                                tooltip:
                                    'Wanna be proactive? Share your availability with venues on your artist profile.'
                            },
                            {
                                SubPoint: 'Get Discovered',
                                subStatus: true,
                                tooltip: 'Increase your visibility. Show up in search results for all venues.'
                            }
                        ],
                        ManagePointsList: [
                            {
                                ManagePoint: 'Public Artist Profiles',
                                manageStatus: true,
                                tooltip:
                                    'Get discovered by the Hedlyner community and anyone off the app. AKA Your new website.'
                            }
                        ]
                    },
                    icon: '/images/global/icon-yes-art.png',
                    disableIcon: '/images/global/icon-no-art.png',
                    button: 'Create Account',
                    authButton: 'Upgrade',
                    isProBtn: 'Downgrade'
                }
            ]
        }
    },
    methods: {
        async checkUser() {
            const data = await api(
                {
                    method: 'get',
                    url: '/api/profile/v1/settings/user'
                },
                { error: false }
            )
            if (data.data && data.data.length) {
                this.userInfo = data.data[0]
                this.isArtist = data.data[0].isArtist
                this.isVenue = data.data[0].isVenue
                this.isVerified = data.data[0].isVerifiedEmail
            }
        },
        showModal() {
            this.showPaymentModal = !this.showPaymentModal
        },
        fetchPaymentMethods() {
            axios
                .get('/profile/stripe/get-payment-methods')
                .then((response) => {
                    this.paymentMethods = response.data.data
                })
                .catch((error) => {
                    notification('error', error)
                })
        },
        async checkSub() {
            const response = await axios.get('/api/profile/stripe/get-plans')
            this.plans = response.data.data
        }
    },
    computed: {
        getPaymentMethods() {
            return this.paymentMethods
        }
    },
    async created() {
        await this.checkUser()
        if (this.isVerified && (this.isArtist || this.isVenue)) {
            await this.fetchPaymentMethods()
            await this.checkSub()
        }
    }
}
